
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19716.75 -24586.75 16.236 15.5"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_6959","data-name":"Group 6959","transform":"translate(-20877 -24532)","opacity":".74"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"line","d":"M0 0h5.429","transform":"translate(1169.881 -51.285)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"line-2","d":"M0 0v5.429","data-name":"line","transform":"translate(1172.596 -54)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"path","d":"M2.388 2.1A.366.366 0 0 0 2 2.488v4.654a.366.366 0 0 0 .388.388h5.041a.366.366 0 0 0 .388-.388V2.488a.366.366 0 0 0-.388-.388z","transform":"translate(1159 -56.061)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"path-2","d":"M30.429 29.529a.366.366 0 0 0 .388-.388v-4.653a.366.366 0 0 0-.388-.388h-5.041a.366.366 0 0 0-.388.388v4.654a.366.366 0 0 0 .388.388z","data-name":"path","transform":"translate(1144.92 -69.529)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"path-3","d":"M2.388 24.1a.366.366 0 0 0-.388.388v4.654a.366.366 0 0 0 .388.388h5.041a.366.366 0 0 0 .388-.388v-4.654a.366.366 0 0 0-.388-.388z","data-name":"path","transform":"translate(1159 -69.529)"}})])])
          )
        }
      }
    